const data = {
  "error404": {
    "fact": "Oeps",
    "slogan": "Verkeerde afslag",
    "message": "Je bent naar een pagina geleid die niet bestaat. We helpen je graag de weg weer terug te vinden.",
    "button": "Klantenservice"
  },
  "generalError": {
    "fact": "Oeps",
    "slogan": "Naar de knoppen.",
    "message": "Sorry, onze website is offline. We gaan meteen op een heleboel knopjes drukken om zo snel mogelijk weer in de lucht te zijn. In de tussentijd kun je de pagina opnieuw proberen te laden, of contact met ons opnemen via Twitter of Facebook.",
    "button": "Pagina opnieuw laden",
    "callOption": "of bel 010 7988999",
    "customerServiceSchedule": "Onze klantenservice is tot 23.59 uur geopend",
    "customerServiceAltText": "Klantenservice"
  }
};

export default data;